import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { DoorvraagType } from '@components/lib/models/generic/doorvraagtype.enum';
import { Antwoord } from '@models/claims';
import { VraagboomMultiResultaat, VraagboomNumberResultaat, VraagboomTextResultaat } from '@models/vragenboom';
import { BaseSummaryControlDirective } from '../base/base-summary-control';

@Component({
  selector: 'app-multiselect-doorvragen-summary',
  templateUrl: './multiselect-doorvragen-summary.component.html',
  styleUrls: ['./multiselect-doorvragen-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiselectDoorvragenSummaryComponent extends BaseSummaryControlDirective<VraagboomMultiResultaat> implements OnInit {
  private antwoordenDictionary: Map<Antwoord, Antwoord[]> = new Map<Antwoord, Antwoord[]>();

  doorvraagType = DoorvraagType;
  hoofdAntwoorden: Antwoord[];

  constructor() {
    super();
  }

  ngOnInit(): void {
    const vraag = this.antwoordResultaat.vraag;
    if ((vraag?.antwoorden?.length ?? 0) == 0)
      return;

    vraag.antwoorden
      .filter(antwoord => this.antwoordResultaat.antwoorden.findIndex(a => a.id === antwoord.id) >= 0)
      .map(x => x.groep_id)
      .filter(this.onlyUnique)
      .forEach(groepId => {
        vraag.antwoorden.filter(x => x.groep_id === groepId)
          .forEach((antwoord, index, antwoorden) => {
            if (index == 0)
              this.antwoordenDictionary.set(antwoord, []);
            else
              this.antwoordenDictionary.get(antwoorden[0]).push(antwoord);
          })
      });

    this.hoofdAntwoorden = Array.from(this.antwoordenDictionary.keys());
  }

  private onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  getSubAntwoorden(hoofdAntwoord: Antwoord): Antwoord[] {
    if (!this.antwoordenDictionary)
      return [];

    return this.antwoordenDictionary.get(hoofdAntwoord);
  }

  getAntwoordResultaat(antwoord: Antwoord): string {
    let resultaatText: string = '';
    const resultaat = this.antwoordResultaat?.resultaat?.resultaten?.get(antwoord.id);
    if (!resultaat)
      return resultaatText;

    if (resultaat instanceof VraagboomNumberResultaat)
      resultaatText = (resultaat as VraagboomNumberResultaat).value;
    else if (resultaat instanceof VraagboomTextResultaat)
      resultaatText = (resultaat as VraagboomTextResultaat).value;

    return resultaatText;
  }
}
